import { useSyncExternalStore } from 'react';

const HISTORY_CHANGE_EVENT = 'imagery:historychange';

let isHistoryPatched = false;

// Browsers only emit popstate for back/forward, so MFE pushes go unobserved.
function patchHistory() {
  if (isHistoryPatched || typeof window === 'undefined') return;
  isHistoryPatched = true;

  (['pushState', 'replaceState'] as const).forEach((method) => {
    const original = window.history[method];

    window.history[method] = function patched(this: History, ...args) {
      const result = original.apply(this, args);
      window.dispatchEvent(new Event(HISTORY_CHANGE_EVENT));
      return result;
    };
  });
}

function subscribe(onStoreChange: () => void) {
  patchHistory();
  window.addEventListener('popstate', onStoreChange);
  window.addEventListener(HISTORY_CHANGE_EVENT, onStoreChange);

  return () => {
    window.removeEventListener('popstate', onStoreChange);
    window.removeEventListener(HISTORY_CHANGE_EVENT, onStoreChange);
  };
}

const getSnapshot = () => window.location.pathname;

// Prefer useLocation for anything the host router owns; this exists for the hall MFE's routes.
export function useLivePathname(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
